import { makeStyles } from "@material-ui/core";

const styles = makeStyles(() => ({
  root: {
    height: "100%",
    lineHeight: "32px",
    margin: "0 10px",
    pointerEvents: "none",
  },
}));

export default styles;
